import React, {useState} from "react";
import VkUserProjectData from "../../../Interfaces/VkUserProjectData";
import * as Sentry from "@sentry/react";
import Loader from "../../Common/Loader";
import {Button} from "react-bootstrap";
var pluralize = require('pluralize-ru');

interface MyVideoListItemProps {
    data: VkUserProjectData,
    index: number,
    onImageLoaded: (data: VkUserProjectData) => void
}

const MyVideoListItem: React.FC<MyVideoListItemProps> = ({
                                                             data,
                                                             index,
                                                             onImageLoaded
                                                         }) => {

    const [isThumbImageLoaded, setIsThumbImageLoaded] = useState(false);
    const [isThumbImageLoadFailed, setIsThumbImageLoadFailed] = useState(false);

    const onClick = () => {
        if (data.downloadUrl !== '') {
            window.open(data.downloadUrl, "_blank", "noreferrer");
        }
    }

    return (
        <div className={`my-video-item`} key={data.vp + data.responseTime}>
            <div>
                <div className={`image-container ${isThumbImageLoaded ? 'loaded' : ''} ${isThumbImageLoadFailed ? 'load-failed' : ''}`}
                     onClick={() => onClick()}>
                    <img
                        src={data.thumbnailUrl}
                        className={'img-fluid'}
                        onLoad={() => {
                            setIsThumbImageLoaded(true);
                        }}
                        onError={(e) => {
                            let src = (e.target as HTMLImageElement).src;
                            let url = new URL(src);
                            if (!url.searchParams.has('i') || (url.searchParams.has('i') && parseInt(url.searchParams.get('i') ?? '') < 5)) {
                                url.searchParams.set('r', (new Date()).getTime().toString());
                                url.searchParams.set('i', url.searchParams.has('i') ? (parseInt(url.searchParams.get('i') ?? '') + 1).toString() : '1');
                                setTimeout(() => {
                                    (e.target as HTMLImageElement).src = url.toString();
                                }, 2000);
                            } else {
                                Sentry.captureException(
                                    new Error('Failed to load theme thumbnail.'),
                                    {
                                        extra: {src: (e.target as HTMLImageElement).src}
                                    }
                                );
                                setIsThumbImageLoadFailed(true);
                            }
                        }}
                        onClick={() => onClick()}
                    />
                    <Loader showTransparentImage={true}
                            isPositionAbsolute={false}
                            isLoaded={isThumbImageLoaded}
                            onLoad={onImageLoaded}/>

                    <div className={'upload-error-container'}>
                        <div className={'upload-error'}></div>
                    </div>
                </div>
                {
                    isThumbImageLoaded || isThumbImageLoadFailed ?
                        <div className={'project-text'}>
                            <div className={'text1'}>
                                {data.createdAtStr}, <b>{data.numSlides}</b> {pluralize(data.numSlides, 'слайдов', 'слайд', 'слайда', 'слайдов')}.<br/>
                                {
                                    data.isRenderDone ? 'Видео хранится 30 дней.' : ''
                                }
                            </div>
                            <div className={'text1'}>
                                {
                                    data.isRenderDone ?
                                        <span>
                                            {
                                                data.isDeleted ? '' :
                                                    <Button
                                                        size={"sm"}
                                                        onClick={() => onClick()}>
                                                        Скачать
                                                    </Button>
                                            }
                                        </span> :
                                        <div>
                                            Делаем видео,&nbsp;
                                            {
                                                data.minutesLeft > 0 ?
                                                    <span>осталось примерно {data.minutesLeft} {pluralize(data.minutesLeft, 'минут', 'минута', 'минуты', 'минут')}</span>
                                                    :
                                                    <span>почти готово</span>
                                            }
                                        </div>
                                }
                            </div>
                        </div> : ''
                }
                <span className="index">{index + 1}</span>
            </div>
        </div>
    )
}

export default MyVideoListItem;